import configureStore, { history as browserHistory } from './configureStore'

const store = configureStore()

export const history = browserHistory

export default store



// WEBPACK FOOTER //
// ./src/store/index.js